// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"a4854848","453":"33dae0e8","477":"f3467f90"}[chunkId] + ".chunk.js";
};